<template>
	<section id="dj-footer" class="bg-white border-t-[10px] border-dj-red" data-type="12230908">
		<footer
			class="max-w-dj-lg mx-auto px-7 pt-7 sm:flex sm:flex-wrap sm:justify-center sm:py-16 md:max-w-dj-base md:justify-between md:flex-nowrap lg:max-w-dj-lg lg:px-0"
		>
			<div class="sm:basis-80 sm:mx-4 md:mx-0">
				<NuxtLink class="block max-w-[170px] sm:max-w-[235px] mb-2" :to="`/${locale}`">
					<DjLogo v-if="region != ''" :region="region" />
				</NuxtLink>
				<h6 class="text-base text-dj-black mt-5">{{ $t("footer.slogan") }}</h6>
				<BaseText class="text-dj-grey mt-3">{{ $t("footer.copy") }}</BaseText>
				<SocialIcons class="mt-2 md:hidden" />
				<a v-if="region === 'RO'" href="https://startup-hub.ro/" target="_blank" rel="noopener noreferrer">
					<img
						class="block max-w-[229px] md:mt-6 mx-auto"
						src="https://res.cloudinary.com/djbs/image/upload/f_auto,q_auto,c_fit,w_229/v1775822643/content/DreamJobs/Graphics/DJ_powered_logo.png"
						:srcset="`
							https://res.cloudinary.com/djbs/image/upload/f_auto,q_auto,c_fit,w_229/v1775822643/content/DreamJobs/Graphics/DJ_powered_logo.png 1x,
							https://res.cloudinary.com/djbs/image/upload/f_auto,q_auto,c_fit,w_458/v1775822643/content/DreamJobs/Graphics/DJ_powered_logo.png 2x
						`"
						alt="StartUp HUB"
					/>
				</a>
				<img
					v-else
					class="block max-w-[229px] md:mt-6 mx-auto"
					src="https://res.cloudinary.com/djbs/image/upload/f_auto,q_auto,c_fit,w_229/v1775822643/content/DreamJobs/Graphics/powered_by_MG.png"
					:srcset="`
						https://res.cloudinary.com/djbs/image/upload/f_auto,q_auto,c_fit,w_229/v1775822643/content/DreamJobs/Graphics/powered_by_MG.png 1x,
						https://res.cloudinary.com/djbs/image/upload/f_auto,q_auto,c_fit,w_458/v1775822643/content/DreamJobs/Graphics/powered_by_MG.png 2x
					`"
					alt="Powered by MG"
				/>
				<NuxtLink
					v-if="region != 'RO'"
					class="block mt-2"
					:to="
						locale == 'hu'
							? 'https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf'
							: 'http://simplepartner.hu/PaymentService/Payment_information.pdf'
					"
					target="_blank"
				>
					<img
						class="w-full max-w-[320px] md:mt-10"
						src="https://res.cloudinary.com/djbs/image/upload/v1656506913/content/DreamJobs/Graphics/pic_simplepay.png"
						alt="SimplePay"
					/>
				</NuxtLink>
				<NuxtLink v-else class="block mt-2" :to="'https://www.euplatesc.ro/'" target="_blank">
					<img
						class="block mx-auto w-full max-w-[150px] md:mt-10"
						src="https://res.cloudinary.com/djbs/image/upload/c_scale,cs_srgb,f_auto,q_auto:best/v1626248565/content/payment/EuPlatesc-logo.svg"
						alt="euPlatesc"
					/>
				</NuxtLink>
			</div>
			<div class="hidden ml-8 mr-4 md:block md:basis-auto">
				<h6 class="text-sm text-dj-grey leading-[48px] mb-2">{{ $t("footer.menu") }}</h6>
				<NuxtLink
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/jobs`"
				>
					{{ $t("navmenu.jobs") }}
				</NuxtLink>
				<NuxtLink
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/companies`"
				>
					{{ $t("navmenu.companies") }}
				</NuxtLink>
				<NuxtLink
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/blog`"
				>
					{{ $t("navmenu.magazine") }}
				</NuxtLink>

				<NuxtLink
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/business/prices`"
				>
					{{ $t("navmenu.why") }}
				</NuxtLink>
				<NuxtLink
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="region == 'HU' ? `/${locale}/company/dreamjobs` : `/${locale}/company/dreamjobs-romania`"
				>
					{{ $t("navmenu.ourteam") }}
				</NuxtLink>
				<NuxtLink
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/contact-us`"
				>
					{{ $t("navmenu.contact") }}
				</NuxtLink>
			</div>
			<div class="hidden ml-4 mr-8 md:block md:basis-auto">
				<h6 class="text-sm text-dj-grey leading-[48px] mb-2">{{ $t("footer.joinUs") }}</h6>
				<NuxtLink
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/registration`"
				>
					{{ $t("registrationUser") }}
				</NuxtLink>
				<NuxtLink
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`https://dashboard.dreamjobs.${region}/${locale}/business`"
					target="_blank"
				>
					{{ $t("navmenu.employers.registrationEmployer") }}
				</NuxtLink>
				<SocialIcons />
			</div>
			<div class="hidden ml-4 mr-8 md:block md:basis-auto">
				<h6 class="text-sm text-dj-grey leading-[48px] mb-2">{{ $t("footer.forEmployers") }}</h6>

				<a
					v-if="!globalConfig.isBlue"
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:href="`https://sbp.dreamjobs.${region}/${$i18n.locale}/self-branding-profile-landing`"
					target="_blank"
				>
					{{ $t("navmenu.sbp") }}
				</a>
				<NuxtLink
					v-if="region === 'HU' || region === 'RO'"
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="salaryCalculatorUrl"
				>
					{{ $t("berkalkulator.shortTitle") }}
				</NuxtLink>
				<NuxtLink
					v-if="globalConfig.isNotBlueHU && region === 'HU'"
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/fizetesek`"
				>
					Fizetések
				</NuxtLink>
				<NuxtLink
					v-if="isAuth"
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/user/notifications`"
				>
					{{ $t("user.notifications.jobsShort") }}
				</NuxtLink>
				<NuxtLink
					v-else
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/jobnotification`"
				>
					{{ $t("user.notifications.jobsShort") }}
				</NuxtLink>
				<NuxtLink
					v-if="region === 'RO'"
					class="block capitalize text-sm py-3 text-dj-black hover:text-dj-grey-dark active:text-dj-grey-dark mr-6"
					:to="`/${locale}/junior-jobs`"
				>
					{{ $t("landings.junior-jobs.submenu") }}
				</NuxtLink>
			</div>
		</footer>
	</section>
	<section class="bg-dj-red">
		<div class="mx-auto flex items-center justify-start max-w-dj-lg px-7 py-7 md:px-14">
			<BaseIcon class="mr-12" color="white" icon="ic:outline-favorite" :width="20" :height="20" />

			<div
				v-if="showLegalDocs"
				class="flex flex-col justify-center items-start ml-auto sm:flex-row sm:items-center"
			>
				<a
					class="text-xs text-white hover:text-dj-grey-dark active:text-dj-grey-dark mr-2 md:mr-6 leading-5"
					:href="getDocumentUrl(LegalDocType.ASZF, region, $i18n.locale)"
					target="_blank"
				>
					{{ $t("footer.terms") }}
				</a>
				<a
					class="text-xs text-white hover:text-dj-grey-dark active:text-dj-grey-dark mr-2 md:mr-6 leading-5"
					:href="getDocumentUrl(LegalDocType.PRIVACY, region, $i18n.locale)"
					target="_blank"
				>
					{{ $t("footer.privacy") }}
				</a>
				<a
					v-if="region === 'HU'"
					class="text-xs text-white hover:text-dj-grey-dark active:text-dj-grey-dark mr-2 md:mr-6 leading-5"
					href="https://dashboard.dreamjobs.hu/docs/jogi-nyilatkozat.pdf"
					target="_blank"
				>
					{{ $t("footer.disclaimer") }}
				</a>
				<a
					class="text-xs text-white hover:text-dj-grey-dark active:text-dj-grey-dark mr-2 md:mr-6 leading-5"
					:href="getDocumentUrl(LegalDocType.COOKIE, region, $i18n.locale)"
					target="_blank"
				>
					{{ $t("footer.cookie") }}
				</a>
				<a
					v-if="isSzmdPeriod"
					class="text-xs text-white hover:text-dj-grey-dark active:text-dj-grey-dark mr-2 md:mr-6 leading-5"
					:href="getDocumentUrl(LegalDocType.PRIZE_GAME, region, $i18n.locale)"
					target="_blank"
				>
					{{ $t("footer.prize-game-rules") }}
				</a>
				<NuxtLink
					class="text-xs text-white hover:text-dj-grey-dark active:text-dj-grey-dark mr-2 md:mr-6 leading-5"
					:to="`/${locale}/contact-us`"
				>
					{{ $t("footer.contact") }}
				</NuxtLink>
			</div>
		</div>
	</section>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import SocialIcons from "../Social/SocialIcons.vue";
import { getDocumentUrl, LegalDocType } from "~/utils/legalDocs";
import { ConfigRepository } from "~~/repositories/ConfigRepository";

export default defineComponent({
	name: "Footer",
	components: { SocialIcons },
	setup() {
		const { locale } = useI18n({
			useScope: "global",
		});

		const { isSzmdPeriod } = useSzmdConfig();

		const isAuth = useState("isAuth");

		const region = ref("");
		const salaryCalculatorUrl = ref("");
		let legalDocs = useState("legalDocs");
		const showLegalDocs = ref(false);

		onMounted(() => {
			region.value = useRegion.getCurrentRegion().code;
			const configRepo = new ConfigRepository();
			salaryCalculatorUrl.value = configRepo.getSalaryCalculatorUrl(locale.value);
			showLegalDocs.value = true;
		});

		watch(locale, () => {
			const configRepo = new ConfigRepository();
			salaryCalculatorUrl.value = configRepo.getSalaryCalculatorUrl(locale.value);
		});

		return {
			locale,
			region,
			salaryCalculatorUrl,
			legalDocs,
			showLegalDocs,
			isAuth,
			isSzmdPeriod,
			getDocumentUrl,
			LegalDocType,
		};
	},
});
</script>
